"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_client-summary.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var renderAccountManager = function renderAccountManager(accountManager) {
  if (!accountManager) {
    return null;
  }

  var imageUrl = accountManager.imageUrl,
      firstName = accountManager.firstName,
      lastName = accountManager.lastName;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "client-summary__members__manager"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
    height: "30px",
    width: "30px",
    circular: true,
    defaultImageIcon: "user",
    imageUrl: imageUrl
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: true,
    label: true
  }, "".concat(firstName, " ").concat(lastName)));
};

function ClientSummary(_ref) {
  var imageUrl = _ref.imageUrl,
      name = _ref.name,
      atRisk = _ref.atRisk,
      brandingDescription = _ref.brandingDescription,
      usersCount = _ref.usersCount,
      accountManager = _ref.accountManager,
      organisationId = _ref.organisationId;
  return /*#__PURE__*/_react.default.createElement(_uiKit.List.CardItem, {
    coverImageProps: {
      imageUrl: imageUrl
    },
    smallestCoverImage: true,
    className: "client-summary"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "client-summary-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "client-summary-header"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading4: true,
    noMargin: true
  }, name), atRisk && /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    tooltipLabel: "Client at-risk",
    tooltipId: "".concat(organisationId, "-at-risk"),
    name: "alert",
    color: "redApple",
    size: "16"
  })), brandingDescription && /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "client-summary__description"
  }, brandingDescription), /*#__PURE__*/_react.default.createElement("div", {
    className: "client-summary__members"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    label: true
  }, "".concat(usersCount, " user").concat(usersCount === 1 ? '' : 's')), renderAccountManager(accountManager))));
}

ClientSummary.displayName = 'ClientSummary';

var _default = (0, _react.memo)(ClientSummary);

exports.default = _default;